import _URL from '../../../Commons/URL/index'

export default {
    _API: _URL._API,
    _PUB_API: _URL._PUB
}